import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
    
import { Stock } from '../../interfaces/stock.interface';
import { Product } from '../../interfaces/product.interface';
import { WarehouseCode } from '../../interfaces/warehousecode.interface';
import { StockService } from "../../services/stock";
import { ProductcodeService } from "../../services/productcode";
import { WarehousecodeService } from "../../services/warehousecode";
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder  } from '@angular/forms';
import { Router } from '@angular/router';


@Component({
  selector: 'app-add-stock',
  imports: [ReactiveFormsModule],
  templateUrl: './add-stock.html',
  styleUrl: './add-stock.css'
})
export class AddStockComponent implements OnInit {

  myForm: FormGroup;
  stock: Stock[] = [];
  warehousecodes: WarehouseCode[] = [];
  products: Product[] = [];

  constructor(
              private stockService: StockService, 
              private cdr: ChangeDetectorRef,
              private router: Router,
              private fb: FormBuilder,
              private productService: ProductcodeService,
              private warehousecodeService: WarehousecodeService) 
              {
                this.myForm = this.fb.group({
                  productcode: new FormControl('',[Validators.required,Validators.maxLength(25)]),
                  warehousecode: new FormControl('',[Validators.required,Validators.maxLength(25)]),
                  stockdate: new FormControl('',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  volume: new FormControl('',[Validators.required,Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  volumeid: new FormControl('',[Validators.required,Validators.maxLength(1)]),
                  value: new FormControl('',[Validators.required,Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  allocatedvolume: new FormControl('',[Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  producttype: new FormControl('',[Validators.required,Validators.maxLength(1)]),
                  uploaded: new FormControl('0000-00-00',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]) 
                });
              }

 async ngOnInit(): Promise<void>
 {

    try 
    {
      this.products = await this.productService.getProductcodes();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getproducts in stock',error);
    }

    try 
    {
      this.warehousecodes = await this.warehousecodeService.getWarehousecodes();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getwarehousecodes in stock',error);
    }

      // set reasonable defaults
      //this.model.volumeid = "B"; 
      //this.model.producttype = "I"; 
    }
   
 async addStock(): Promise<void>
  {

    var productcode = this.myForm.value.productcode != null ? this.myForm.value.productcode.trim() : "";
    var warehousecode = this.myForm.value.warehousecode != null ? this.myForm.value.warehousecode.trim() : "";
    var stockdate = this.myForm.value.stockdate != null ? this.myForm.value.stockdate.trim() : "";
    var volume = this.myForm.value.volume != null ? this.myForm.value.volume : 0;
    var volumeid = this.myForm.value.volumeid != null ? this.myForm.value.volumeid.trim() : "";
    var value = this.myForm.value.value != null ? this.myForm.value.value : 0;
    var allocatedvolume = this.myForm.value.allocatedvolume != null ? this.myForm.value.allocatedvolume : 0;
    var producttype = this.myForm.value.producttype != null ? this.myForm.value.producttype.trim() : "";
    var uploaded = this.myForm.value.uploaded != null ? this.myForm.value.uploaded.trim() : "0000-00-00";


    if (this.myForm.invalid && this.myForm.touched)
    {
      return;
    }

 try
        {
          await this.stockService.create(productcode,warehousecode,stockdate,volume,volumeid,value,allocatedvolume,producttype,uploaded);
          this.cdr.detectChanges();
          this.router.navigateByUrl('stock'); 
        } catch (error) {
          console.error('createstock error',error);
        }

  }   

   get productcode() {
    return this.myForm.get('productcode');
  }
  get warehousecode() {
    return this.myForm.get('warehousecode');
  }
  get stockdate() {
    return this.myForm.get('stockdate');
  }
  get volume() {
    return this.myForm.get('volume');
  }
  get volumeid() {
    return this.myForm.get('volumeid');
  }
  get value() {
    return this.myForm.get('value');
  }
  get allocatedvolume() { 
    return this.myForm.get('allocatedvolume');
  }
  get producttype() {
    return this.myForm.get('producttype');
  } 
  get uploaded() {
    return this.myForm.get('uploaded');
  }

   goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('stock');
  }

}
